import { render } from "./OrderForm.vue?vue&type=template&id=3627ae4b"
import script from "./OrderForm.vue?vue&type=script&lang=js"
export * from "./OrderForm.vue?vue&type=script&lang=js"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__